import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TeamMemberCard = ({ member, onViewDetails }) => {
  const getStatusColor = () => {
    switch (member?.status) {
      case 'Aktiv': return 'bg-success';
      case 'Pause': return 'bg-warning';
      case 'Offline': return 'bg-muted-foreground';
      default: return 'bg-muted-foreground';
    }
  };

  const getWorkloadColor = () => {
    if (member?.workloadPercentage >= 90) return 'bg-error';
    if (member?.workloadPercentage >= 70) return 'bg-warning';
    return 'bg-success';
  };

  return (
    <div className="bg-card rounded-lg p-4 border border-border hover:bg-muted/50 transition-colors cursor-pointer" onClick={() => onViewDetails(member)}>
      <div className="flex items-start gap-3">
        <div className="relative">
          <Image 
            src={member?.avatar} 
            alt={member?.avatarAlt}
            className="w-12 h-12 rounded-full object-cover"
          />
          <div className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-card ${getStatusColor()}`} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-foreground truncate">{member?.name}</h4>
          <p className="text-xs text-muted-foreground">{member?.role}</p>
          <div className="flex items-center gap-2 mt-2">
            <div className="flex items-center gap-1">
              <Icon name="Users" size={12} className="text-muted-foreground" />
              <span className="text-xs text-muted-foreground">{member?.activeClients}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Clock" size={12} className="text-muted-foreground" />
              <span className="text-xs text-muted-foreground">{member?.hoursToday}h</span>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs text-muted-foreground">Auslastung</span>
          <span className="text-xs font-medium text-foreground">{member?.workloadPercentage}%</span>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className={`h-full ${getWorkloadColor()} transition-all duration-300`}
            style={{ width: `${member?.workloadPercentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default TeamMemberCard;